<lib-prod-grid [title]="prodGridTitle"
               [icon]="'dataset'"
               [columns]="prodGridColumns"
               [class]="companyTab ? 'site-tab' : ''"
               [isAddButtonShown]="true"
               [isRemoveButtonShown]="true"
               [isAddButtonDisabled]="isAddButtonDisabled"
               [isRemoveButtonDisabled]="isRemoveButtonDisabled"
               [matTableDataSource]="matTableDataSource"
               [inputAction$]="inputAction$"
               (outputAction$)="outputActionEvents($event)"></lib-prod-grid>
